export default __webpack_public_path__ + "static/article-taking-out-a-used-car-loan-7b1240112bde8867c621808c82827616.jpg";